import React, { useState, useEffect } from "react";
import { useWindowDimensions } from "./utils";

import PropTypes from "prop-types";

export const Responsive = ({ minWidth, maxWidth, children, as, ...props }) => {
  const { width } = useWindowDimensions();
  const [visible, setVisible] = useState(false);

  const withinMinThreshold = width >= minWidth;
  const withinMaxThreshold = width <= maxWidth;

  useEffect(() => {
    if (minWidth && maxWidth) {
      setVisible(withinMinThreshold && withinMaxThreshold);
    } else if (minWidth) {
      setVisible(withinMinThreshold);
    } else if (maxWidth) {
      setVisible(withinMaxThreshold);
    }
  }, [width, minWidth, maxWidth]);

  if (!visible) return null;

  const Component = as || "div";
  return <Component {...props}>{children}</Component>;
};

Responsive.onlyMobile = { minWidth: 320, maxWidth: 767 };
Responsive.onlyTablet = { minWidth: 768, maxWidth: 991 };
Responsive.onlyComputer = { minWidth: 992 };
Responsive.onlyLargeScreen = { minWidth: 1200, maxWidth: 1919 };
Responsive.onlyWidescreen = { minWidth: 1920 };

Responsive.propTypes = {
  minWidth: PropTypes.number,
  maxWidth: PropTypes.number,
  as: PropTypes.func,
  children: PropTypes.node,
};

